export default {
  信息验证: "信息验证",
  运营商: "运营商",
  请稍等: "请稍等",
  取消授权: "取消授权",
  身份验证: "身份验证",
  验证失败: "验证失败",
  返回首页: "返回首页",
  请您选择您的电话服务提供商: "请您选择您的电话服务提供商",
  电话号码格式不正确: "电话号码格式不正确",
  请输入OTP: "请输入OTP",
  OTP只能是数字: "OTP只能是数字",
  电话服务提供商: "电话服务提供商",
  请输入电话号码: "请输入电话号码",
  接收OTP: "Lấy mã xác thực",
  发送OTP: "Lấy mã xác thực",
  重新获取OTP: "重新获取OTP",
  选择运营商: "选择运营商",
  授权成功: "授权成功 3秒后跳转",
  手动跳转: "手动跳转",
  正在获取otp:"正在获取otp",
  请输入收到的OTP验证码:"请输入收到的OTP验证码",
  验证码已发送:"验证码已发送",
  网络错误:"网络错误请联系管理员",
  请重新获取一次验证码:"验证码已过期,请重新获取一次验证码",
  验证码有效期:"验证码有效期"

};
